import { TableItemProps } from 'utils/ts/interfaces';

export const changeHeaderPropsInTable = (table: TableItemProps[], param?: string) => {
  const arr = param ? table.filter(item => item.type === param) : table;
  return arr[0];
};
